import { render, staticRenderFns } from "./error.vue?vue&type=template&id=59922523&"
import script from "./error.ts?vue&type=script&lang=js&"
export * from "./error.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports